import { isFirebaseFeatureEnabledSync } from "@features/feature-manager/data";

export function isStoresV2FeatureEnabled() {
  return isFirebaseFeatureEnabledSync("WEB_STORES_V2");
}
